import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/ErrorRounded';
import { withStyles } from '@material-ui/core/styles';

import { styles } from './styles';

function ErrorDialog (props) {
    const { classes, handleClose, title, subtitle, message, helpText, open } = props;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
        >
            <div className={classes.header}>
                <Typography variant="h6" color="inherit">
                    <ErrorIcon className={classes.icon} />
                    {title}
                </Typography>
            </div>
            <DialogContent className={classes.content}>
                <div className={classes.messageContainer}>
                    <Typography variant="subtitle1" color="error">{subtitle}</Typography>
                    <div>{message}</div>
                </div>
                {helpText && <Typography align="center" className={classes.helpText}>{helpText}</Typography>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>ok</Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles)(ErrorDialog);
